// ═══════════════════════════════════════
// STATE — Variables d'état partagées
// ═══════════════════════════════════════

export let sessionToken = localStorage.getItem('auth_token') || null;
export let currentUser  = JSON.parse(localStorage.getItem('auth_user') || 'null');
export let pendingAction = null;
export let currentId = null;
export let currentSlug = null;
export let currentPartitionMeta = null; // { is_owner, is_public }
export let headerFormActive = false;

export function setSessionToken(v)        { sessionToken = v; }
export function setCurrentUser(v)         { currentUser = v; }
export function setPendingAction(v)       { pendingAction = v; }
export function setCurrentId(v)           { currentId = v; }
export function setCurrentSlug(v)         { currentSlug = v; }
export function setCurrentPartitionMeta(v){ currentPartitionMeta = v; }
export function setHeaderFormActive(v)    { headerFormActive = v; }
